var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCatalogIcon = function SvgCatalogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#213D38",
    fillRule: "evenodd",
    d: "M18.7 5.354V5.3h-.064zM10.932 5.3H3.3v1.4h6.432a5.7 5.7 0 0 1 1.2-1.4m-1.17 7.4a5.8 5.8 0 0 1-.629-1.4H3.3v1.4H9.76m7.367 4.6H3.3v1.4h14.762z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#213D38",
    strokeLinecap: "square",
    strokeWidth: 1.4,
    d: "M16.789 12.998 20.117 18M11.08 8.922c-.426 2.005.904 3.987 2.97 4.426s4.087-.83 4.514-2.835c.426-2.005-.904-3.987-2.97-4.426s-4.087.83-4.514 2.835Z"
  })));
};
export default SvgCatalogIcon;